import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    hidden: true,
    redirect: '/home',
  },
  {
    path: '/:catchAll(.*)',
    hidden: true,
    component: () => import('@/views/404.vue'),
  },
  {
    path: '/login',
    hidden: true,
    component: () => import('@/views/Login/index.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/fuwu/jihua/print',
    hidden: true,
    component: () => import('@/views/Fuwu/Jihua/print.vue'),
    meta: {
      title: '打印',
    },
  },
  {
    path: '/home',
    redirect: '/home/index',
    component: () => import('@/layout/index.vue'),
    meta: {
      title: '控制台',
      icon: 'home',
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/Home/index.vue'),
        meta: {
          title: '控制台',
        },
      },
      {
        path: 'xiaoxi',
        component: () => import('@/views/Home/xiaoxi.vue'),
        meta: {
          title: '我的待办',
        },
      },
      {
        path: 'tongxunlu',
        auth: 'app:tongxunlu',
        component: () => import('@/views/Home/tongxunlu.vue'),
        meta: {
          title: '通讯录',
        },
      },
    ],
  },
  {
    path: '/zonghe',
    auth: 'app:zonghe',
    component: () => import('@/layout/index.vue'),
    meta: {
      title: '综合管理',
      icon: 'circle',
    },
    children: [
      {
        path: 'banner',
        auth: 'app:homeBanner',
        redirect: '/zonghe/banner/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '首页轮播图',
        },
        children: [
          {
            path: 'index',
            auth: 'app:homeBanner',
            hidden: true,
            component: () => import('@/views/Zonghe/Banner/index.vue'),
            meta: {
              title: '轮播图列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:homeBanner',
            hidden: true,
            component: () => import('@/views/Zonghe/Banner/detail.vue'),
            meta: {
              title: '轮播图详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:homeBanner',
            hidden: true,
            component: () => import('@/views/Zonghe/Banner/edit.vue'),
            meta: {
              title: '轮播图编辑',
            },
          },
        ],
      },
      {
        path: 'news',
        auth: 'app:news',
        redirect: '/zonghe/news/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '新闻管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:news',
            hidden: true,
            component: () => import('@/views/Zonghe/News/index.vue'),
            meta: {
              title: '新闻列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:news',
            hidden: true,
            component: () => import('@/views/Zonghe/News/detail.vue'),
            meta: {
              title: '新闻详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:news',
            hidden: true,
            component: () => import('@/views/Zonghe/News/edit.vue'),
            meta: {
              title: '新闻编辑',
            },
          },
        ],
      },
      {
        path: 'dianhua',
        auth: 'app:dianhua',
        redirect: '/zonghe/dianhua/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '电话管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:dianhua',
            hidden: true,
            component: () => import('@/views/Zonghe/Dianhua/index.vue'),
            meta: {
              title: '电话列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:dianhua',
            hidden: true,
            component: () => import('@/views/Zonghe/Dianhua/detail.vue'),
            meta: {
              title: '电话详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:dianhua',
            hidden: true,
            component: () => import('@/views/Zonghe/Dianhua/edit.vue'),
            meta: {
              title: '电话编辑',
            },
          },
        ],
      },
    ],
  },
  {
    path: '/xiaoshou',
    auth: 'app:xiaoshou',
    component: () => import('@/layout/index.vue'),
    meta: {
      title: '销售管理',
      icon: 'tag',
    },
    children: [
      {
        path: 'renwu',
        auth: 'app:xiaoshouRenwu',
        redirect: '/xiaoshou/renwu/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '销售任务',
        },
        children: [
          {
            path: 'index',
            auth: 'app:xiaoshouRenwu',
            hidden: true,
            component: () => import('@/views/Xiaoshou/Renwu/index.vue'),
            meta: {
              title: '任务列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:xiaoshouRenwu',
            hidden: true,
            component: () => import('@/views/Xiaoshou/Renwu/detail.vue'),
            meta: {
              title: '任务详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:xiaoshouRenwu',
            hidden: true,
            component: () => import('@/views/Xiaoshou/Renwu/edit.vue'),
            meta: {
              title: '任务编辑',
            },
          },
        ],
      },
      {
        path: 'kehu',
        auth: 'app:xiaoshouKehu',
        redirect: '/xiaoshou/kehu/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '意向客户',
        },
        children: [
          {
            path: 'index',
            auth: 'app:xiaoshouKehu',
            hidden: true,
            component: () => import('@/views/Xiaoshou/Kehu/index.vue'),
            meta: {
              title: '客户列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:xiaoshouKehu',
            hidden: true,
            component: () => import('@/views/Xiaoshou/Kehu/detail.vue'),
            meta: {
              title: '客户详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:xiaoshouKehu',
            hidden: true,
            component: () => import('@/views/Xiaoshou/Kehu/edit.vue'),
            meta: {
              title: '客户编辑',
            },
          },
        ],
      },
      {
        path: 'genzong',
        auth: 'app:xiaoshouGenzong',
        redirect: '/xiaoshou/genzong/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '拜访记录',
        },
        children: [
          {
            path: 'index',
            auth: 'app:xiaoshouGenzong',
            hidden: true,
            component: () => import('@/views/Xiaoshou/Genzong/index.vue'),
            meta: {
              title: '记录列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:xiaoshouGenzong',
            hidden: true,
            component: () => import('@/views/Xiaoshou/Genzong/detail.vue'),
            meta: {
              title: '记录详情',
            },
          },
        ],
      },
    ],
  },
  {
    path: '/shangcheng',
    auth: 'app:shangcheng',
    component: () => import('@/layout/index.vue'),
    meta: {
      title: '商城管理',
      icon: 'shop',
    },
    children: [
      {
        path: 'banner',
        auth: 'app:shangchengBanner',
        redirect: '/shangcheng/banner/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '商城轮播图',
        },
        children: [
          {
            path: 'index',
            auth: 'app:shangchengBanner',
            hidden: true,
            component: () => import('@/views/Shangcheng/Banner/index.vue'),
            meta: {
              title: '轮播图列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:shangchengBanner',
            hidden: true,
            component: () => import('@/views/Shangcheng/Banner/detail.vue'),
            meta: {
              title: '轮播图详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:shangchengBanner',
            hidden: true,
            component: () => import('@/views/Shangcheng/Banner/edit.vue'),
            meta: {
              title: '轮播图编辑',
            },
          },
        ],
      },
      {
        path: 'shangpin/fenlei',
        auth: 'app:shangpinFenlei',
        redirect: '/shangcheng/shangpin/fenlei/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '商品分类管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:shangpinFenlei',
            hidden: true,
            component: () => import('@/views/Shangcheng/ShangpinFenlei/index.vue'),
            meta: {
              title: '分类列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:shangpinFenlei',
            hidden: true,
            component: () => import('@/views/Shangcheng/ShangpinFenlei/detail.vue'),
            meta: {
              title: '分类详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:shangpinFenlei',
            hidden: true,
            component: () => import('@/views/Shangcheng/ShangpinFenlei/edit.vue'),
            meta: {
              title: '分类编辑',
            },
          },
        ],
      },
      {
        path: 'shangpin',
        auth: 'app:shangpin',
        redirect: '/shangcheng/shangpin/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '商品管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:shangpin',
            hidden: true,
            component: () => import('@/views/Shangcheng/Shangpin/index.vue'),
            meta: {
              title: '商品列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:shangpin',
            hidden: true,
            component: () => import('@/views/Shangcheng/Shangpin/detail.vue'),
            meta: {
              title: '商品详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:shangpin',
            hidden: true,
            component: () => import('@/views/Shangcheng/Shangpin/edit.vue'),
            meta: {
              title: '商品编辑',
            },
          },
        ],
      },
      {
        path: 'dingdan/admin',
        auth: 'app:dingdanAdmin',
        redirect: '/shangcheng/dingdan/admin/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '商城订单',
        },
        children: [
          {
            path: 'index',
            auth: 'app:dingdanAdmin',
            hidden: true,
            component: () => import('@/views/Shangcheng/DingdanAdmin/index.vue'),
            meta: {
              title: '订单列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:dingdanAdmin',
            hidden: true,
            component: () => import('@/views/Shangcheng/DingdanAdmin/detail.vue'),
            meta: {
              title: '订单详情',
            },
          },
        ],
      },
      {
        path: 'dingdan/user',
        auth: 'app:dingdanUser',
        redirect: '/shangcheng/dingdan/user/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '我的订单',
        },
        children: [
          {
            path: 'index',
            auth: 'app:dingdanUser',
            hidden: true,
            component: () => import('@/views/Shangcheng/DingdanUser/index.vue'),
            meta: {
              title: '订单列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:dingdanUser',
            hidden: true,
            component: () => import('@/views/Shangcheng/DingdanUser/detail.vue'),
            meta: {
              title: '订单详情',
            },
          },
        ],
      },
    ],
  },
  {
    path: '/xingzheng',
    auth: 'app:xingzheng',
    component: () => import('@/layout/index.vue'),
    meta: {
      title: '行政管理',
      icon: 'calendar',
    },
    children: [
      {
        path: 'user',
        auth: 'app:user',
        redirect: '/xingzheng/user/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '用户管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:user',
            hidden: true,
            component: () => import('@/views/Xingzheng/User/index.vue'),
            meta: {
              title: '用户列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:user',
            hidden: true,
            component: () => import('@/views/Xingzheng/User/detail.vue'),
            meta: {
              title: '用户详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:user',
            hidden: true,
            component: () => import('@/views/Xingzheng/User/edit.vue'),
            meta: {
              title: '用户编辑',
            },
          },
        ],
      },
      {
        path: 'kaoqinJilu',
        auth: 'app:kaoqinJilu',
        redirect: '/xingzheng/kaoqinJilu/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '考勤记录',
        },
        children: [
          {
            path: 'index',
            auth: 'app:kaoqinJilu',
            hidden: true,
            component: () => import('@/views/Xingzheng/KaoqinJilu/index.vue'),
            meta: {
              title: '考勤列表',
            },
          },
        ],
      },
      {
        path: 'gongzi',
        auth: 'app:gongzi',
        redirect: '/xingzheng/gongzi/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '工资管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:gongzi',
            hidden: true,
            component: () => import('@/views/Xingzheng/Gongzi/index.vue'),
            meta: {
              title: '工资列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:gongzi',
            hidden: true,
            component: () => import('@/views/Xingzheng/Gongzi/detail.vue'),
            meta: {
              title: '工资详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:gongzi',
            hidden: true,
            component: () => import('@/views/Xingzheng/Gongzi/edit.vue'),
            meta: {
              title: '工资编辑',
            },
          },
        ],
      },
    ],
  },
  {
    path: '/danwei',
    auth: 'app:danwei',
    component: () => import('@/layout/index.vue'),
    meta: {
      title: '单位管理',
      icon: 'activity',
    },
    children: [
      {
        path: 'hezuo',
        auth: 'app:hezuo',
        redirect: '/danwei/hezuo/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '合作单位管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:hezuo',
            hidden: true,
            component: () => import('@/views/Danwei/Hezuo/index.vue'),
            meta: {
              title: '单位列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:hezuo',
            hidden: true,
            component: () => import('@/views/Danwei/Hezuo/detail.vue'),
            meta: {
              title: '单位详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:hezuo',
            hidden: true,
            component: () => import('@/views/Danwei/Hezuo/edit.vue'),
            meta: {
              title: '单位编辑',
            },
          },
        ],
      },
      {
        path: 'hezuoUser',
        auth: 'app:hezuoUser',
        redirect: '/danwei/hezuoUser/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '合作单位账号管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:hezuoUser',
            hidden: true,
            component: () => import('@/views/Danwei/HezuoUser/index.vue'),
            meta: {
              title: '账号列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:hezuoUser',
            hidden: true,
            component: () => import('@/views/Danwei/HezuoUser/detail.vue'),
            meta: {
              title: '账号详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:hezuoUser',
            hidden: true,
            component: () => import('@/views/Danwei/HezuoUser/edit.vue'),
            meta: {
              title: '账号编辑',
            },
          },
        ],
      },
      {
        path: 'jiguan',
        auth: 'app:jiguan',
        redirect: '/danwei/jiguan/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '机关单位管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:jiguan',
            hidden: true,
            component: () => import('@/views/Danwei/Jiguan/index.vue'),
            meta: {
              title: '单位列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:jiguan',
            hidden: true,
            component: () => import('@/views/Danwei/Jiguan/detail.vue'),
            meta: {
              title: '单位详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:jiguan',
            hidden: true,
            component: () => import('@/views/Danwei/Jiguan/edit.vue'),
            meta: {
              title: '单位编辑',
            },
          },
        ],
      },
      {
        path: 'jiguanUser',
        auth: 'app:jiguanUser',
        redirect: '/danwei/jiguanUser/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '机关单位账号管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:jiguanUser',
            hidden: true,
            component: () => import('@/views/Danwei/JiguanUser/index.vue'),
            meta: {
              title: '账号列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:jiguanUser',
            hidden: true,
            component: () => import('@/views/Danwei/JiguanUser/detail.vue'),
            meta: {
              title: '账号详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:jiguanUser',
            hidden: true,
            component: () => import('@/views/Danwei/JiguanUser/edit.vue'),
            meta: {
              title: '账号编辑',
            },
          },
        ],
      },
    ],
  },
  {
    path: '/fuwu',
    auth: 'app:fuwu',
    component: () => import('@/layout/index.vue'),
    meta: {
      title: '服务执行',
      icon: 'file',
    },
    children: [
      {
        path: 'pingtai',
        auth: 'app:pingtai',
        redirect: '/fuwu/pingtai/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '环保平台管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:pingtai',
            hidden: true,
            component: () => import('@/views/Fuwu/Pingtai/index.vue'),
            meta: {
              title: '平台列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:pingtai',
            hidden: true,
            component: () => import('@/views/Fuwu/Pingtai/detail.vue'),
            meta: {
              title: '平台详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:pingtai',
            hidden: true,
            component: () => import('@/views/Fuwu/Pingtai/edit.vue'),
            meta: {
              title: '平台编辑',
            },
          },
        ],
      },
      {
        path: 'pingtaiUser',
        auth: 'app:pingtaiUser',
        redirect: '/fuwu/pingtaiUser/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '平台账号管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:pingtaiUser',
            hidden: true,
            component: () => import('@/views/Fuwu/PingtaiUser/index.vue'),
            meta: {
              title: '平台账号列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:pingtaiUser',
            hidden: true,
            component: () => import('@/views/Fuwu/PingtaiUser/detail.vue'),
            meta: {
              title: '平台账号详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:pingtaiUser',
            hidden: true,
            component: () => import('@/views/Fuwu/PingtaiUser/edit.vue'),
            meta: {
              title: '平台账号编辑',
            },
          },
        ],
      },
      {
        path: 'kehu',
        auth: 'app:kehu',
        redirect: '/fuwu/kehu/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '客户管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:kehu',
            hidden: true,
            component: () => import('@/views/Fuwu/Kehu/index.vue'),
            meta: {
              title: '客户列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:kehu',
            hidden: true,
            component: () => import('@/views/Fuwu/Kehu/detail.vue'),
            meta: {
              title: '客户详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:kehu',
            hidden: true,
            component: () => import('@/views/Fuwu/Kehu/edit.vue'),
            meta: {
              title: '客户编辑',
            },
          },
        ],
      },
      {
        path: 'kehuUser',
        auth: 'app:kehuUser',
        redirect: '/fuwu/kehuUser/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '企业账号管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:kehuUser',
            hidden: true,
            component: () => import('@/views/Fuwu/KehuUser/index.vue'),
            meta: {
              title: '企业账号列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:kehuUser',
            hidden: true,
            component: () => import('@/views/Fuwu/KehuUser/detail.vue'),
            meta: {
              title: '企业账号详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:kehuUser',
            hidden: true,
            component: () => import('@/views/Fuwu/KehuUser/edit.vue'),
            meta: {
              title: '企业账号编辑',
            },
          },
        ],
      },
      {
        path: 'zhengshu',
        auth: 'app:zhengshu',
        redirect: '/fuwu/zhengshu/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '证件管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:zhengshu',
            hidden: true,
            component: () => import('@/views/Fuwu/Zhengshu/index.vue'),
            meta: {
              title: '证件列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:zhengshu',
            hidden: true,
            component: () => import('@/views/Fuwu/Zhengshu/detail.vue'),
            meta: {
              title: '证件详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:zhengshu',
            hidden: true,
            component: () => import('@/views/Fuwu/Zhengshu/edit.vue'),
            meta: {
              title: '证件编辑',
            },
          },
        ],
      },
      {
        path: 'shipin',
        auth: 'app:shipin',
        redirect: '/fuwu/shipin/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '监控管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:shipin',
            hidden: true,
            component: () => import('@/views/Fuwu/Shipin/index.vue'),
            meta: {
              title: '监控列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:shipin',
            hidden: true,
            component: () => import('@/views/Fuwu/Shipin/detail.vue'),
            meta: {
              title: '监控详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:shipin',
            hidden: true,
            component: () => import('@/views/Fuwu/Shipin/edit.vue'),
            meta: {
              title: '监控编辑',
            },
          },
        ],
      },
      {
        path: 'ziliao',
        auth: 'app:ziliao',
        redirect: '/fuwu/ziliao/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '执行管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:ziliao',
            hidden: true,
            component: () => import('@/views/Fuwu/Ziliao/index.vue'),
            meta: {
              title: '执行列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:ziliao',
            hidden: true,
            component: () => import('@/views/Fuwu/Ziliao/detail.vue'),
            meta: {
              title: '执行详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:ziliao',
            hidden: true,
            component: () => import('@/views/Fuwu/Ziliao/edit.vue'),
            meta: {
              title: '执行编辑',
            },
          },
        ],
      },
      {
        path: 'dangan',
        auth: 'app:dangan',
        redirect: '/fuwu/dangan/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '档案管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:dangan',
            hidden: true,
            component: () => import('@/views/Fuwu/Dangan/index.vue'),
            meta: {
              title: '档案列表',
            },
          },
        ],
      },
      {
        path: 'hetong',
        auth: 'app:hetong',
        redirect: '/fuwu/hetong/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '合同管理',
        },
        children: [
          {
            path: 'index',
            auth: 'app:hetong',
            hidden: true,
            component: () => import('@/views/Fuwu/Hetong/index.vue'),
            meta: {
              title: '合同列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:hetong',
            hidden: true,
            component: () => import('@/views/Fuwu/Hetong/detail.vue'),
            meta: {
              title: '合同详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:hetong',
            hidden: true,
            component: () => import('@/views/Fuwu/Hetong/edit.vue'),
            meta: {
              title: '合同编辑',
            },
          },
        ],
      },
      {
        path: 'jihua',
        auth: 'app:jihua',
        redirect: '/fuwu/jihua/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '工作计划',
        },
        children: [
          {
            path: 'index',
            auth: 'app:jihua',
            hidden: true,
            component: () => import('@/views/Fuwu/Jihua/index.vue'),
            meta: {
              title: '计划列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:jihua',
            hidden: true,
            component: () => import('@/views/Fuwu/Jihua/detail.vue'),
            meta: {
              title: '计划详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:jihua',
            hidden: true,
            component: () => import('@/views/Fuwu/Jihua/edit.vue'),
            meta: {
              title: '计划编辑',
            },
          },
        ],
      },
      {
        path: 'neirong',
        auth: 'app:neirong',
        redirect: '/fuwu/neirong/index',
        component: () => import('@/views/index.vue'),
        meta: {
          title: '工作内容',
        },
        children: [
          {
            path: 'index',
            auth: 'app:neirong',
            hidden: true,
            component: () => import('@/views/Fuwu/Neirong/index.vue'),
            meta: {
              title: '内容列表',
            },
          },
          {
            path: 'detail',
            auth: 'app:neirong',
            hidden: true,
            component: () => import('@/views/Fuwu/Neirong/detail.vue'),
            meta: {
              title: '内容详情',
            },
          },
          {
            path: 'edit',
            auth: 'app:neirong',
            hidden: true,
            component: () => import('@/views/Fuwu/Neirong/edit.vue'),
            meta: {
              title: '内容编辑',
            },
          },
          {
            path: 'batch',
            auth: 'app:neirong',
            hidden: true,
            component: () => import('@/views/Fuwu/Neirong/batch.vue'),
            meta: {
              title: '批量添加',
            },
          },
          {
            path: 'zhixing',
            auth: 'app:neirong',
            hidden: true,
            component: () => import('@/views/Fuwu/Neirong/zhixing.vue'),
            meta: {
              title: '内容执行',
            },
          },
        ],
      },
      {
        path: 'wenjian',
        auth: 'app:wenjian',
        component: () => import('@/views/Fuwu/Wenjian/index.vue'),
        meta: {
          title: '文件检索',
        },
      },
    ],
  },
  {
    path: '/system',
    auth: 'app:system',
    component: () => import('@/layout/index.vue'),
    meta: {
      title: '系统设置',
      icon: 'settings',
    },
    children: [
      {
        path: 'setting',
        auth: 'app:setting',
        component: () => import('@/views/System/Setting/index.vue'),
        meta: {
          title: '系统设置',
        },
      },
      {
        path: 'kaoqin/shezhi',
        auth: 'app:kaoqinShezhi',
        component: () => import('@/views/System/kaoqinShezhi/index.vue'),
        meta: {
          title: '考勤设置',
        },
      },
      {
        path: 'kaoqin/guize',
        auth: 'app:kaoqinGuize',
        component: () => import('@/views/System/kaoqinGuize/index.vue'),
        meta: {
          title: '考勤规则',
        },
      },
      {
        path: 'yonghu/xieyi',
        auth: 'app:yonghuXieyi',
        component: () => import('@/views/System/yonghuXieyi/index.vue'),
        meta: {
          title: '用户协议',
        },
      },
      {
        path: 'yinsi/zhengce',
        auth: 'app:yinsiZhengce',
        component: () => import('@/views/System/yinsiZhengce/index.vue'),
        meta: {
          title: '隐私政策',
        },
      },
      {
        path: 'quhua',
        auth: 'app:quhua',
        component: () => import('@/views/System/Quhua/index.vue'),
        meta: {
          title: '区域管理',
        },
      },
      {
        path: 'jigou',
        auth: 'app:jigou',
        component: () => import('@/views/System/Jigou/index.vue'),
        meta: {
          title: '机构管理',
        },
      },
      {
        path: 'ziyuan',
        auth: 'app:ziyuan',
        component: () => import('@/views/System/Ziyuan/index.vue'),
        meta: {
          title: '资源管理',
        },
      },
      {
        path: 'jiaose',
        auth: 'app:jiaose',
        component: () => import('@/views/System/Jiaose/index.vue'),
        meta: {
          title: '角色管理',
        },
      },
      {
        path: 'password',
        component: () => import('@/views/System/Password'),
        meta: {
          title: '修改密码',
        },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory('#'),
  routes,
})

export default router
